class DeliverySaverConfirmationController {
    constructor($state, $location, $q, deliverySaverService, settings) {
        this.$state = $state;
        this.$location = $location;
        this.$q = $q;
        this.deliverySaverService = deliverySaverService;
        this.settings = settings;
    }

    $onInit() {
        this.subscription = this.$state.params.data.Subscription;
        this.plan = this.$state.params.data.Plan;
        this.isAnnualPlan = false;

        if (!this.subscription || !this.plan) {
            this.loading = true;
            this.deliverySaverService.getSubscription()
                .then((data) => {
                    // temporarily solution, will be replaced by new design soon
                    if (!data.Subscription || data.Subscription.Status === 'Cancelled') {
                        return this.$q.reject();
                    }
                    return data;
                })
                .then((data) => {
                    this.subscription = data.Subscription;
                    this.plan = data.Plan;
                    this.isAnnualPlan = this.plan.BillingFrequencyMonths === 12;
                })
                .catch(() => {
                    this.$location.path(this.settings.deliverySaver.discoverPageUrl);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}

DeliverySaverConfirmationController.$inject = ['$state', '$location', '$q', 'DeliverySaverService', 'Settings'];

const DeliverySaverConfirmationComponentDefinition = {
    controller: DeliverySaverConfirmationController,
    template: require('./delivery-saver-confirmation.component.html').trim(),
};

module.exports = {
    DeliverySaverConfirmationController,
    DeliverySaverConfirmationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/confirmation/delivery-saver-confirmation.component.js